import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
const indoLocale = {
    firstDayOfWeek: 1,
    weekdays: {
        shorthand: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        longhand: [
            'Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'
        ],
    },
    months: {
        shorthand: [
            'Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
            'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'
        ],
        longhand: [
            'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
            'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ],
    },
};

export function initTanggalSingleAja(selector) {
    flatpickr(selector, {
        locale: Indonesian,
        altInput: true,
        altFormat: "l, d M Y",
        dateFormat: "Y-m-d",
        minDate: "today",
    });
}

export function initTanggalSingle(selector) {
    const today = new Date();
    today.setHours(6, 0, 0, 0); // ✅ set jam 06:00

    flatpickr(selector, {
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "d-m-Y H:i",
        minDate: "today",
        defaultDate: today,
        locale: indoLocale,
        appendTo: document.body,
        position: "above",
    });

}

export function initTanggalSingleEnd(selector) {
    const today = new Date();
    today.setHours(23, 59, 0, 0);

    flatpickr(selector, {
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "Y-m-d H:i",
        minDate: "today",
        defaultDate: today,
        locale: indoLocale,
        appendTo: document.body,
        position: "above",
    });

}

export function initTanggalRange(selector) {
    flatpickr(selector, {
        mode: "range",
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "d-m-Y H:i",
        minDate: "today",
        locale: indoLocale,
        showMonths: 2,
        defaultDate: getDefaultTanggalRange(),
        onOpen: function (selectedDates, dateStr, instance) {
            if (!selectedDates.length) {
                instance.clear();
            }
        },
        plugins: [
            confirmDatePlugin({
                confirmText: "Set",     // ✅ Tombol konfirmasi
                showAlways: true,       // selalu muncul
                theme: "light"          // bisa "dark" kalau perlu
            })
        ]
    });
}

function getDefaultTanggalRange() {
    const now = new Date();
    now.setHours(6, 0, 0, 0); // hari ini jam 06:00

    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);

    return [now, tomorrow]; // default: hari ini 06:00 sampai besok 06:00
}
